<content>
    <form [formGroup]="sendInvitationForm" [ngClass]="{'show-error':showError}">
        <div class="entry-5-modal">
            <label>{{'usuarios.auditor.modal.entidad' | translate}} *</label>
            <app-filterable-list [itemsList]="entidadesControl" [selectedItem]="sendInvitationForm.get('entidad')" [placeHolder]="false" [disabled]="disabledEntidades">
            </app-filterable-list>
        </div>
        <div class="entry-5-modal">
            <label>{{'usuarios.auditor.modal.email' | translate}} *</label>
            <input type="email" formControlName="email">
        </div>
        <div class="entry-5-modal">
            <label>{{'usuarios.auditor.modal.timezone' | translate}} *</label>
            <app-filterable-list class="shorter-list" [itemsList]="timezones" [selectedItem]="sendInvitationForm.get('msTimeZone')" [placeHolder]="false"></app-filterable-list>
        </div>
        <div class="entry-5-modal">
            <label>{{'usuarios.auditor.modal.idioma' | translate}} *</label>
            <app-filterable-list class="shorter-list" [itemsList]="idiomas" [selectedItem]="sendInvitationForm.get('idioma')" [placeHolder]="false"></app-filterable-list>
        </div>
        <div class="entry-5-modal" *ngIf="this.role !== 'Supervisor'">
            <input type="checkbox" id="permisoEscritura" formControlName="permisoEscritura">
            <label for="permisoEscritura">{{'usuarios.auditor.modal.permisoEscritura' | translate}}</label>
        </div>
    </form>
</content>
<footer class="button-bar-right">
    <button class="secondary" (click)="close()">{{'global.cancelar' | translate}}</button>
    <button (click)="send()">{{'global.enviar' | translate }}</button>
</footer>
<app-toast *ngIf="showError && mensajes" [messages]="mensajes" (closed)="showError=$event"></app-toast>
